// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3_Y8y","search":"Settings_search__2LpdC","filter":"Settings_filter__3c5JV"};